<template>
	<v-container fluid>
		<v-row align="start">
			<v-col cols="3">
				<v-select
					label="Tipo de unidade de exploração"
					outlined
					hide-details
					v-model="csTipoUepList"
					multiple
					item-text="dsTipoUep"
                    item-value="csTipoUep"
					:items="uepTypes"
          			clearable
					:menu-props="{
						offsetY: true,
						bottom: true
					}"
				/>
			</v-col>
			<v-col cols="3">
				<v-text-field
					label="Produtor"
					outlined
          clearable
					hide-details
					v-model="nmProdutor"
				/>
			</v-col>
			<v-col cols="3">
				<v-text-field
					label="Pavilhão"
					outlined
					hide-details
          clearable
					v-model="nrPavilhao"
				/>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					label="Extensionista"
					outlined
          clearable
					hide-details
					v-model="nmExtensionista"
					:items="technicalManagers"
					item-text="nmPessoa"
					item-value="nmPessoa"
          :loading="loadingTechnicalManagers"
				/>
			</v-col>
      <v-col cols="3">
				<menu-datepicker
					label="Data"
					outlined
					v-model="dtAlojamento"
				/>
			</v-col>
			<v-col>
				<v-btn dark rounded color="primary" @click="onApplyClick">
					Atualizar
					<v-icon small style="margin-left: 4px; margin-bottom: 2px">fa-sync-alt</v-icon>
				</v-btn>
				<v-btn rounded color="#e8e8e8" style="margin-left: 5px;" @click="onClearData">
					Limpar Busca
					<v-icon small style="margin-left: 4px; margin-bottom: 2px">fas fa-eraser</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import MenuDatepicker from '@/modules/common/components/MenuDatepicker';
import { validationMixin } from 'vuelidate';
import moment from 'moment';
import requiredIf from 'vuelidate/lib/validators/requiredIf';

export default {
	name: 'MortalityControlFilters',
	mixins: [validationMixin],
	validations() {
		return {
			dtAlojadoDe: {
				required: requiredIf('dtAlojadoAte')
			},
			dtAlojadoAte: {
				required: requiredIf('dtAlojadoDe')
			}
		};
	},
	components: { MenuDatepicker },
	data: () => ({
		csTipoUepList: [],
    dtAlojamento: null,
		nmProdutor: null,
		nrPavilhao: null,
		nmExtensionista: null,

		loadingTechnicalManagers: false,
		technicalManagers: []
	}),
	computed: {
		uepTypes() {
            return [
                {csTipoUep: 'CR', dsTipoUep: 'Creche'},
                {csTipoUep: 'TR', dsTipoUep: 'Terminação'},
                {csTipoUep: 'WF', dsTipoUep: 'Wean to Finish'},
                {csTipoUep: 'UP', dsTipoUep: 'UPL'}
            ];
        }
	},
	methods: {
		onClearData() {
		  this.csTipoUepList = []
      this.dtAlojamento = null
		  this.nmProdutor = null
		  this.nrPavilhao = null
		  this.nmExtensionista = null
			this.$emit('clear')
		},
		onApplyClick() {
			this.$v.$touch();
			if (this.$v.$invalid) return;
			const query = {};
      	if (this.dtAlojamento)
        query['dtAlojamento'] = moment(this.dtAlojamento, "DD/MM/YYYY").format('YYYY-MM-DD')
			if (this.nmProdutor && this.nmProdutor !== '')
				query['nmProdutor'] = this.nmProdutor;
			if (this.nmExtensionista && this.nmExtensionista !== '')
				query['nmExtensionista'] = this.nmExtensionista;
			if (this.nrPavilhao && this.nrPavilhao !== '')
				query['nrPavilhao'] = this.nrPavilhao;
			if (this.csTipoUepList && this.csTipoUepList.length > 0)
				query['csTipoUep'] = this.csTipoUepList.join(',');

			if (Object.keys(query).length === 0) this.$emit('apply', null);
			else this.$emit('apply', query);
		},
		listTechnicalManagers() {
			this.loadingTechnicalManagers = true;
			this.$axios
				.get('responsavel-tecnico/responsavel_tecnico_ativo/')
				.then(res => {
					if (!res.data) return;
					if (!res.data[0]) return;
					if (!res.data[0].data) return;

					this.technicalManagers = res.data[0].data;
				})
				.catch(error => {
					this.$store.commit('setSnack', {
						type: 'error',
						msg: error
					});
				})
				.finally(() => (this.loadingTechnicalManagers = false));
		}
	},
	mounted() {
		this.listTechnicalManagers();
	}
};
</script>

<style scoped></style>
